class WebsocketLog {

	constructor(url) {
		this.url = url;
		this.messageListeners = [];
		this.closeListeners = [];		
	}
	
	open() {
		const socket = new WebSocket(this.url);
	
		socket.addEventListener('message', (event) => {
			const data = event.data;
			this.onMessage(data);
		});
		
		socket.addEventListener('open', (event) => {
			this.sendKeepAlive();
		});
	
		socket.addEventListener('close', (event) => {
			this.onClose(event);
			clearTimeout(this.timeoutID);
		});	
		
		
		this.socket = socket;
	}
	
	close() {
		if( this.socket ) {
			this.socket.close();
		}
	} 
	
	addMessageListener(listener) {
		this.messageListeners.push(listener);
	}
	
	addCloseListener(listener) {
		this.closeListeners.push(listener);
	}
	
	onMessage(message) {
		this.resetKeepAlive();
		
		const object = JSON.parse(message);	
		this.messageListeners.forEach(f => f(object));
	}
	
	onClose(event) {
		this.clearKeepAlive();
		this.closeListeners.forEach(f => f());
	}
	
	clearKeepAlive() {
		if( this.timeoutID ) {
			clearTimeout(this.timeoutID);
		}  
	}
	
	resetKeepAlive() {
		this.clearKeepAlive();
		this.sendKeepAlive()
	}
	
	sendKeepAlive() {
		// send keep alive messages
		this.timeoutID = setTimeout(() => {
			this.socket.send('PING');
			
			// queue next message
			this.sendKeepAlive();
		}, 10000);
	}	
}

const websocket_log = (url) => {
	return new WebsocketLog(url);
}


export {
	websocket_log
}
	  